export const getDefaultSegments = (hotels, level = "HOTEL") => {
    if (hotels?.length > 1) {
        return [level === "HOTEL" ? 'HOTELS' : 'GROUPS'];
    }

    if (hotels?.length === 1) {
        return ['CAMPAIGN'];
    }
    return [];
}